"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Play } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnleashYourInnerBeast() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222254" id="restoring-stability-and-dignity" className="dark bg-background text-foreground min-h-[100dvh] flex flex-col lg:flex-row relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px] animate-pulse" />
        <div className="absolute bottom-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-chart-3/10 blur-[100px]" />
      </div>

      {}
      <div className="flex-1 flex flex-col justify-center px-6 py-20 sm:px-12 lg:px-20 xl:px-24 z-10 relative">
        <div ref={textRef} className={`transition-all duration-1000 ease-out flex flex-col gap-8 ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="flex flex-col select-none">
            <h1 className="font-default text-[14vw] sm:text-[10vw] lg:text-[7vw] xl:text-[8vw] font-bold uppercase leading-[0.85] tracking-tighter text-foreground drop-shadow-sm">
              Restoring
              <br />
              <span className="text-foreground/80">Stability</span>
            </h1>
            <h2 className="font-default text-[10vw] sm:text-[7vw] lg:text-[5vw] xl:text-[5.5vw] font-bold uppercase leading-[0.9] tracking-tighter mt-2 lg:mt-4 bg-gradient-to-r from-primary via-primary to-chart-2 bg-clip-text text-transparent drop-shadow-md">
              Dignity &
              <br />
              Opportunity
            </h2>
          </div>

          <p className="font-default text-lg sm:text-xl text-muted-foreground max-w-xl mt-4">
            The Trust Foundation is dedicated to empowering individuals through mentorship, life skills, and pathways to independent living. Join us in building a stronger community.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-6">
            <Button asChild size="lg" className="h-16 px-8 rounded-full text-lg font-semibold uppercase tracking-wider bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300">
              <Link to="/SupportUsPage">
                Join the Mission
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-16 px-8 rounded-full text-lg font-semibold uppercase tracking-wider border-2 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 bg-transparent">
              <Link to="/OurStoryPage">Our Impact</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-screen z-10 overflow-hidden bg-card">
        <div ref={imageRef} className={`absolute inset-0 w-full h-full transition-all duration-1000 ease-out delay-300 ${isImageVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:bg-gradient-to-r lg:from-background lg:via-background/40 lg:to-transparent z-10" />
          
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654300/img/foundation_mentorship_impact.png" alt="Mentorship and community support in action" className="w-full h-full object-cover object-center grayscale-[0.1] contrast-110 brightness-90 rounded-l-[4rem]" />

          {}
          <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none opacity-40">
            <div className="size-24 rounded-full border border-white/30 flex items-center justify-center backdrop-blur-md bg-white/5">
              <Play className="size-8 text-white ml-2" fill="currentColor" />
            </div>
          </div>

          {}
          <div className="absolute bottom-12 right-12 z-30 rotate-[-6deg] opacity-40 mix-blend-overlay">
            <span className="font-serif italic text-6xl md:text-8xl text-white tracking-widest drop-shadow-2xl">
              TRUST
            </span>
          </div>
        </div>
      </div>
    </section>;
}